import {
  Menu,
  MenuItemLink,
  usePermissions,
  useResourceDefinitions,
  useSidebarState,
  useTranslate,
} from "react-admin";
import useStyles from "./style";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { ListSubheader } from "@mui/material";

const roleMenuItems: Record<string, string[]> = {
  user: ["games", "vouchers"],
};

const roleMenuHeaders: Record<string, string[]> = {
  user: ["Menu", "Gestion"],
};

const CustomMenu = () => {
  const classes = useStyles();
  const { permissions: role, isPending } = usePermissions<string>();
  const [open] = useSidebarState();
  const translate = useTranslate();
  const resources = useResourceDefinitions();
  const items = role ? roleMenuItems[role] || [] : [];
  const headers = role ? roleMenuHeaders[role] || [] : [];

  if (!open || isPending) return null;
  if (!role) return null;

  return (
    <Menu className={classes.menu}>
      <MenuItemLink
        key="dashboard"
        to="/"
        primaryText={translate("ra.gameoo.homePage")}
        leftIcon={<HomeRoundedIcon />}
        className={classes.menuItem}
      />
      <ListSubheader component="div">{headers[0]}</ListSubheader>
      {items.map((name) => {
        const resource = resources[name];
        return (
          <MenuItemLink
            key={name}
            to={`/${name}`}
            primaryText={resource?.options?.label ?? name}
            leftIcon={resource?.icon ? <resource.icon /> : undefined}
            className={classes.menuItem}
          />
        );
      })}
    </Menu>
  );
};

export default CustomMenu;
